
import React, { memo } from "react";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import { connect } from "react-redux";
import * as types from '../../types'
import GridContainer from "src/components/Grid/GridContainer.jsx";
import GridItem from "src/components/Grid/GridItem.jsx";
import Button from "src/components/CustomButtons/Button.jsx";
import { CardMedia, CardContent, CardActionArea, CardActions } from "@material-ui/core";
import Card from "src/components/Card/Card.jsx";
import CustomInput from "src/components/CustomInput/CustomInput.jsx";
import DiscoveryItems from './DiscoveryItems'

import CardBody from "src/components/Card/CardBody.jsx";
import CardIcon from "src/components/Card/CardIcon.jsx";
import CardHeader from "src/components/Card/CardHeader.jsx";
import DiscoverIcon from "../../custom_components/DiscoverIcon"
import { cardTitle } from "src/assets/jss/material-dashboard-pro-react.jsx";
import PodCastTypeDialog from "../podcast/PodCastTypeDialog"
const styles: any = theme => ({

    right: {
        textAlign: "right"
    },
    center: {
        textAlign: "center"
    },

    icon: {
        verticalAlign: "middle",
        width: "17px",
        height: "17px",
        top: "-1px",
        position: "relative"
    },
    positionAbsolute: {
        position: "absolute",
        right: "0",
        top: "0"
    },
    cardIconTitle: {
        ...cardTitle,
        marginTop: "15px",
        marginBottom: "0px"
    },
    categoryButtonDiv: {
        padding: '20px',
        whiteSpace: 'nowrap',
        overflowX: 'auto',


    }
});
interface DiscoveryViewProps {
    classes: any;
    connect: types.IState,

}
export enum SelectedCategory {
    Featured = "Featured",
    News = "News",
    Travel = "Travel",
    Tech = "Tech",
    Photography = "Photography",
    Health = "Health",
    Food = "Food",
    Fitness = "Fitness",
    Finance = "Finance",
    Design = "Design & Development",
    Cryptocurrency = "Cryptocurrency",
    BusinessMarketing = "Business & Marketing",
}
let categories = [

    {
        name: "Tech",
        category: SelectedCategory.Tech
    },
    {
        name: "News",
        category: SelectedCategory.News
    },
    {
        name: "Business & Marketing",
        category: SelectedCategory.BusinessMarketing
    },
    {
        name: "Design & Development",
        category: SelectedCategory.Design
    },
    {
        name: "Finance",
        category: SelectedCategory.Finance
    },
    {
        name: "Travel",
        category: SelectedCategory.Travel
    },


    {
        name: "Health",
        category: SelectedCategory.Health
    },
    {
        name: "Food",
        category: SelectedCategory.Food
    },
    {
        name: "Fitness",
        category: SelectedCategory.Fitness
    },


    {
        name: "Cryptocurrency",
        category: SelectedCategory.Cryptocurrency
    },


]
interface DiscoveryViewState {
    selectedCategory: SelectedCategory;
    podcastTypeDialog: boolean;
    rssUrl: string;
    fieldCheck: any;
    errors: Array<types.ValidationError>;
}
let helper = new types.ValidationHelper();
helper.fields = [
    {
        field: 'rssUrl',
        rules: [new types.RequiredRule(), new types.UrlRule()],

    }

];
class DiscoveryView extends React.Component<DiscoveryViewProps, DiscoveryViewState> {


    constructor(props: DiscoveryViewProps) {
        super(props);

        this.state = {
            selectedCategory: SelectedCategory.Tech,
            podcastTypeDialog: false,
            rssUrl: '',
            fieldCheck: {},
            errors: new Array<types.ValidationError>()
        };

    }
    createAPodCast() {
        let s = {...this.state};
        s.podcastTypeDialog = true;
        this.setState(s);
    }
    render() {

        const { classes } = this.props;
        let me = this;
        let errors = helper.validateForm(this.state).errors;
        let hasErrors = errors.length > 0
        let createPodCastLength = 12;
        if (this.state.rssUrl) {
            createPodCastLength = 10;
        }
        return (
            <GridContainer>
                <Card>
                    <CardHeader color="rose" icon>

                        <CardIcon color="rose">
                            <DiscoverIcon />
                        </CardIcon>
                        <h4 className={classes.cardIconTitle}>Discover</h4>

                    </CardHeader>
                    <CardBody>
                        <GridContainer>
                            <GridItem xs={createPodCastLength} sm={createPodCastLength} md={createPodCastLength}>
                                <div style={{ padding: "10px" }}>
                                    <CustomInput

                                        labelText="Enter the Url or RSS feed Url of the blog you want to make a podcast for."
                                        id="url"
                                        formControlProps={{
                                            fullWidth: true
                                        }}


                                        helpText={helper.getFirstError('rssUrl', this.state.errors)}
                                        success={this.state.fieldCheck['rssUrl'] && !helper.getFirstError('rssUrl', this.state.errors)}
                                        error={helper.getFirstError('rssUrl', this.state.errors)}


                                        value={this.state.rssUrl}
                                        inputProps={{

                                            onChange: (e) => {
                                                let s = { ...me.state };
                                                s.rssUrl = e.target.value;
                                                me.setState(s);

                                            },
                                            onKeyDown: (e) => {


                                                if (e.which === 13) {
                                                    {
                                                        e.stopPropagation();
                                                        if (!hasErrors) {

                                                        }// me.processUrl(e)
                                                        return false;
                                                    }

                                                }
                                            }
                                        }}
                                    />
                                </div>
                            </GridItem>
                            {this.state.rssUrl && (
                                <GridItem xs={2} style={{    marginTop: '25px'

                                
                                
                                }}>
                                    <Button
                                        color="rose"
                                        onClick={this.createAPodCast.bind(this)}
                                        variant="contained"
                                        disabled={hasErrors}

                                        className={classes.registerButton}
                                    >



                                        <span>Make Podcast</span>

                                    </Button>

                                </GridItem>
                            )}
                        </GridContainer>

                        <GridContainer>
                            <div className={classes.categoryButtonDiv}>
                                {categories.map(cat => (


                                    <Button color="rose" simple={cat.category != this.state.selectedCategory} onClick={(e) => {
                                        let s = { ...me.state };
                                        s.selectedCategory = cat.category;
                                        me.setState(s);
                                    }} >
                                        {cat.name}
                                    </Button>


                                ))}
                            </div>
                        </GridContainer>
                        <DiscoveryItems selectedCategory={this.state.selectedCategory} />

                    </CardBody>
                </Card>
                <PodCastTypeDialog
                    open={this.state.podcastTypeDialog}
                    podcastUrl = {this.state.rssUrl}
                    close={() => {
                        let s = { ...me.state };
                        s.podcastTypeDialog = false;
                        me.setState(s)
                    }} />
            </GridContainer>
        )

    }
}

export function mapStateToProps(state: types.IState) {
    return {
        connect: state
    };
}
export default connect(
    mapStateToProps,
    null
)(withStyles(styles as any)(DiscoveryView));







// WEBPACK FOOTER //
// ./src/views/discovery/DiscoveryView.tsx